import React, { Component } from "react";

import styles from "../../../components/Client/styles.module.css";
import SignatureCanvas from "react-signature-canvas";
import { Row, Col, Container } from "react-bootstrap";
import $ from "jquery";
import PROMO_A from "../../../assets/images/error-404.svg";
import {
  getClientFormVerification,
  saveClientResponseVerification,
  saveAgentResponseDraft,
  stopAIAgent,
} from "../../../config/agent_forms_api_calls";
import { REPLACECONTENTCLIENT } from "../../../config/utility";
import {
  THEME_COLOR,
  THEME_TEXT_COLOR,
  VENDOR_SIGNATURE,
} from "../../../config/config";
import "../../../components/Client/agreement.css";
import HelperClass from "../../../config/helperClass";
import MutextField from "@material-ui/core/TextField";
import FormRendererAgent from "../../../components/Reseller/formRenderAgent";
import NotificationToast from "../../../components/Notification/NotificationToast";
import { tableLoaderAgreement } from "../../../components/ContentLoaders/table_loader_agreement";
import parsePhoneNumberFromString from "libphonenumber-js";
import CryptoJS from "crypto-js";
import html2canvas from "html2canvas";
import axios from "axios";
const auth = new HelperClass();

export default class FormVerification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      successMessage: "",
      tableLoaderAgreement: true,
      errorMessageSignee: "",
      successMessageSignee: "",
      replacable_content: "",
      client_accountno: "",
      form_accountno: "",
      form_token: "",
      formData: "",
      form_title: "",
      form_desc: "",
      form_submitted: "3",
      responseMessage: "",
      client_details: [],
      submission_status: "",
      allow_submit: 1,
      link_form: false,
      captcha_enabled: 0,
      external_link: "",
      draftData: [],
      progressStep: 0,
      allow_multiple: 0,
      formRenderKey: 0,
      chatgpt_intergation: "No",
      conversational_ai: "No",
      chatgpt_api_key: "",
      isStoppingAgent: false,
      allow_agent_name: false,
      isSubmitting: false,
      toastMessage: "",
      toastType: "success",
      toastTitle: "",
    };
  }

  showToast = (message, type = "error", title) => {
    this.setState({ toastMessage: "" }, () =>
      this.setState({
        toastMessage: message,
        toastType: type,
        toastTitle: title || (type === "success" ? "Success" : "Error"),
      })
    );
  };

  async componentDidMount() {
    this.setState({ form_token: this.props.match.params.form_token });
    let apiHit = await getClientFormVerification(
      this.props.match.params.form_token
    );
    if (
      apiHit.data.status === 404 &&
      apiHit.data.message === "Invalid Credientials"
    ) {
      //window.location.replace("/error");
      this.setState({
        errorMessage: "Invalid Credentials.",
        successMessage: "",
        tableLoaderAgreement: false,
        form_submitted: 2,
      });
    } else if (
      apiHit.data.status === 404 &&
      apiHit.data.message === "no_record"
    ) {
      this.setState({
        errorMessage:
          "Oops! Your temporary URL has been expired or does not exists.",
        successMessage: "",
        tableLoaderAgreement: false,
        form_submitted: 2,
      });
    } else if (
      apiHit.data.status === 404 &&
      apiHit.data.message === "already_signed"
    ) {
      this.setState({
        errorMessage: "Oops! Agreement already signed.",
        successMessage: "",
        tableLoaderAgreement: false,
        form_submitted: 2,
      });
    } else if (
      apiHit.data.status === 404 &&
      apiHit.data.message === "form_submitted"
    ) {
      this.setState({
        errorMessage: "Oops! Form already submitted.",
        successMessage: "",
        tableLoaderAgreement: false,
        form_submitted: 1,
      });
    } else if (apiHit.data.status === 200) {
      const groupsData = apiHit.data.data[0]["groups"];
      const groups = groupsData ? JSON.parse(groupsData) : [];

      const draftResponse = apiHit.data.draft_response;
      const draftData =
        draftResponse && draftResponse !== "" ? JSON.parse(draftResponse) : [];
      const progress = apiHit.data.progress;
      let progressStep = 0;
      if (progress) {
        const [current, total] = progress.split("/").map(Number);
        progressStep = current < total ? current : 0;
      }

      let chatgpt_intergation = "No";
      let conversational_ai = "No";
      let chatgpt_api_key = "";
      if (
        apiHit.data.integrationInfo &&
        apiHit.data.integrationInfo.length > 0
      ) {
        for (let i = 0; i < apiHit.data.integrationInfo.length; i++) {
          const item = apiHit.data.integrationInfo[i];
          if (
            item["integration_type"] === "chatgpt" &&
            item["active"] === 1 &&
            item["enabled"] === "Yes"
          ) {
            chatgpt_intergation = "Yes";
            if (item["api_key"]) {
              chatgpt_api_key = this.decryptApiKey(item["api_key"]);
            }
          }

          if (
            item["integration_type"] === "conversational" &&
            item["active"] === 1 &&
            item["enabled"] === "Yes"
          ) {
            conversational_ai = "Yes";
          }
        }
      }

      const aiAgentCreation = apiHit.data.data[0]["ai_agent_creation"] === 1;
      const aiAgentLink =
        apiHit.data.data[0]["ai_agent_creation_external_link"];

      const allow_agent_name = aiAgentCreation && aiAgentLink ? true : false;

      this.setState({
        formData: apiHit.data.data[0]["form_content"],
        form_title: apiHit.data.data[0]["form_title"],
        form_desc: apiHit.data.data[0]["form_desc"],
        allow_submit: apiHit.data.data[0]["allow_submit"],
        link_form: apiHit.data.data[0]["link_form"],
        captcha_enabled: apiHit.data.data[0]["captcha_enabled"] || 0,
        external_link: apiHit.data.data[0]["external_link"],
        groups: groups,
        client_accountno: apiHit.data.client_accountno,
        form_accountno: apiHit.data.form_accountno,
        tableLoaderAgreement: false,
        form_submitted: apiHit.data.is_submitted,
        client_details: apiHit.data.client_data,
        draftData: draftData,
        totalSteps: groups.length,
        progressStep: progressStep,
        chatgpt_intergation: chatgpt_intergation,
        chatgpt_api_key: chatgpt_api_key,
        conversational_ai: conversational_ai,
        allow_agent_name: allow_agent_name,
        allow_multiple: apiHit.data.allow_multiple || 0,
      });
    } else {
      this.setState({
        errorMessage:
          "Oops! There is some error while processing your request.",
        successMessage: "",
        tableLoaderAgreement: false,
        form_submitted: 2,
      });
    }
  }

  decryptApiKey = (encryptedValue) => {
    if (!encryptedValue || typeof encryptedValue !== "string") {
      console.error("decryptApiKey: Invalid encrypted value");
      return "";
    }

    try {
      const bytes = CryptoJS.AES.decrypt(
        encryptedValue,
        process.env.REACT_APP_SECRET_AES
      );
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);

      if (!decrypted) {
        console.error("Decryption resulted in empty string");
        return "";
      }

      return decrypted;
    } catch (err) {
      console.error("Decryption failed:", err);
      return "";
    }
  };

  formatPhoneNumber = (phoneNumber) => {
    const phoneNumberObj = parsePhoneNumberFromString(phoneNumber);
    if (phoneNumberObj) {
      if (phoneNumberObj.country === "US") {
        const nationalNumber = phoneNumberObj
          .formatNational()
          .replace(/\D/g, ""); // e.g. "2123727200"
        const areaCode = nationalNumber.slice(0, 3);
        const firstPart = nationalNumber.slice(3, 6);
        const secondPart = nationalNumber.slice(6);
        return `(${areaCode}) ${firstPart}-${secondPart}`;
      }
      return phoneNumberObj.formatInternational();
    }
    return phoneNumber; // Return original number if parsing fails
  };

  clear = () => {
    this.signaturePad.clear();
    $("#divImgSig").hide();
    $(".clsimgSig").attr("src", "");
    $(".clsimgSig").hide();
  };

  handleChange = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.value : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
  };

  handleSaveDraft = (formData, currentStep) => {
    let response = JSON.stringify(formData);
    const draft_result = this.saveDraft(
      response,
      this.state.form_accountno,
      currentStep
    );
    return draft_result;
  };

  saveDraft = async (response, formAccNo, submittedStep) => {
    const { form_token, form_title, form_desc, client_accountno, totalSteps } =
      this.state;
    window.scrollTo({ top: 0, behavior: "smooth" });
    const submitFormReponse = await saveAgentResponseDraft(
      client_accountno,
      response,
      formAccNo,
      form_token,
      form_title,
      form_desc,
      submittedStep,
      totalSteps
    );
    // console.log("saveResponse response: ", submitFormReponse.data);
    if (
      submitFormReponse.data.status === 403 ||
      submitFormReponse.data.errors === "authentication missing" ||
      submitFormReponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (submitFormReponse.data.status === 404) {
      this.setState({ responseMessage: "" });
      this.showToast("There is some error while saving the progress.", "error");
      return false;
    } else if (submitFormReponse.data.status === 200) {
      this.setState({ responseMessage: "" });
      this.showToast("Progress saved successfully.", "success");
      return true;
    }
    setTimeout(() => {
      this.setState({
        errorMessageSaveResponse: "",
        responseMessage: "",
      });
    }, 10000);
  };

  handleSubmitForm = (formData) => {
    let response = JSON.stringify(formData);
    this.saveResponse(response, this.state.form_accountno);
  };

  saveResponse = async (response, formAccNo) => {
    const {
      form_token,
      form_title,
      form_desc,
      client_accountno,
      totalSteps,
      conversational_ai,
    } = this.state;

    window.scrollTo({ top: 0, behavior: "smooth" });
    this.setState({ isSubmitting: true });

    const submitFormReponse = await saveClientResponseVerification(
      client_accountno,
      response,
      formAccNo,
      form_token,
      form_title,
      form_desc,
      totalSteps
    );

    const data = submitFormReponse.data || {};

    if (
      data.status === 403 ||
      data.errors === "authentication missing" ||
      data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (data.status === 404 || data.status === 405) {
      this.setState({ responseMessage: "" });
      this.showToast("There was an error while submitting the form.", "error");
    } else if (data.status === 200) {
      // Show the confirmation state instead of reloading back into the
      // editable form (which previously kept the old answers populated and
      // allowed an overwriting re-submission).
      this.setState({
        errorMessageSaveResponse: "",
        responseMessage: "",
        form_submitted: 1,
        draftData: [],
        isSubmitting: false,
      });
      this.showToast("Your response was submitted successfully!", "success");
    } else {
      this.setState({ responseMessage: "" });
      this.showToast(
        "There was an unexpected error while submitting the form.",
        "error"
      );
    }
    setTimeout(() => {
      this.setState({
        errorMessageSaveResponse: "",
        responseMessage: "",
      });
    }, 10000);
  };

  // For multiple-submission forms: intentionally start a NEW, blank submission.
  submitAnotherResponse = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    this.setState((prevState) => ({
      form_submitted: 0,
      draftData: [],
      progressStep: 0,
      responseMessage: "",
      isSubmitting: false,
      formRenderKey: prevState.formRenderKey + 1,
    }));
  };

  render() {

    return (
      <div className="nk-content form_main_container background-white">
        <NotificationToast
          message={this.state.toastMessage}
          type={this.state.toastType}
          title={this.state.toastTitle}
          onDismiss={() => this.setState({ toastMessage: "" })}
        />
        <div className="container-fluid">
          <div className="nk-content-inner">
            <div className="nk-content-body">
              {this.state.isSubmitting && (
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    zIndex: 10,
                  }}
                >
                  <div
                    className="spinner-border text-primary mb-2"
                    style={{ width: "2.5rem", height: "2.5rem" }}
                    role="status"
                  />
                  <span
                    style={{
                      color: "#555",
                      fontSize: "15px",
                      fontWeight: 500,
                      marginTop: "4px",
                    }}
                  >
                    Submitting your response...
                  </span>
                </div>
              )}

              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      <em className="icon ni ni-list-round"></em> Submit Form
                    </h3>
                  </div>
                </div>
              </div>

              {this.state.successMessage !== "" ? (
                <>
                  <div className="example-alert">
                    <div className="alert alert-pro alert-success">
                      <div className="alert-text">
                        <h4>Success</h4>
                        <p>{this.state.successMessage}</p>
                      </div>
                    </div>
                  </div>
                  <center>
                    <a
                      onClick={this.close_window}
                      className="btn btn-primary mt-2"
                      style={{ color: "#fff" }}
                    >
                      Close Window
                    </a>
                  </center>
                </>
              ) : null}
              {this.state.tableLoaderAgreement === true ? (
                tableLoaderAgreement()
              ) : (
                <>
                  {this.state.link_form === 1 ? (
                    <div className="nk-block mt-4">
                      <div className="nk-block-content nk-error-ld">
                        <h3 className="nk-error-title text-center">
                          Link Only
                        </h3>
                        <div className="alert alert-light text-dark">
                          This form contains an external link.{" "}
                          <a href={this.state.external_link} target="_blank">
                            Click Here
                          </a>{" "}
                          to be redirected to the specified destination.
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      {this.state.form_submitted === 0 ? (
                        <>
                          {this.state.formData &&
                            this.state.formData.length > 0 ? (
                            <div className="nk-block mt-4">
                              <FormRendererAgent
                                key={this.state.formRenderKey}
                                formData={JSON.parse(this.state.formData)}
                                formTitle={this.state.form_title}
                                formDescription={this.state.form_desc}
                                onSubmit={this.handleSubmitForm}
                                onToast={this.showToast}
                                groups={this.state.groups}
                                responseMessage={this.state.responseMessage}
                                clientData={this.state.client_details}
                                chatgpt_intergation={
                                  this.state.chatgpt_intergation
                                }
                                chatgpt_api_key={this.state.chatgpt_api_key}
                                allow_submit={this.state.allow_submit}
                                draftData={this.state.draftData}
                                saveDraft={this.handleSaveDraft}
                                progressStep={this.state.progressStep}
                                viewFrom="agent-not-logged-in"
                                allow_agent_name={this.state.allow_agent_name}
                                isSubmitting={this.state.isSubmitting}
                                captcha_enabled={this.state.captcha_enabled}
                                link_form={this.state.link_form}
                              // id={this.state.forms[0].id}
                              // setShowResponse={(value) => this.setState({ showResponse: value })}
                              />
                            </div>
                          ) : null}
                        </>
                      ) : this.state.form_submitted === 1 ? (
                        <div className="nk-block mt-4">
                          <div className="nk-block-content nk-error-ld text-center">
                            <h3 className="nk-error-title">Form Submitted</h3>
                            <div className="alert alert-light alert-icon text-dark">
                              Thank you for submitting your form. We have
                              successfully received your information and are
                              processing it. Our team will review the details
                              and get back to you shortly if further information
                              is needed. We appreciate your time and effort in
                              providing us with the necessary details.
                            </div>
                            {this.state.allow_multiple === 1 ? (
                              <center>
                                <a
                                  onClick={this.submitAnotherResponse}
                                  className="btn btn-primary mt-2"
                                  style={{ color: "#fff", cursor: "pointer" }}
                                >
                                  Submit Another Response
                                </a>
                              </center>
                            ) : null}
                          </div>
                        </div>
                      ) : this.state.form_submitted === 2 ? (
                        <div className="nk-block mt-4">
                          <div className="nk-block-content nk-error-ld text-center">
                            <h1 className="nk-error-head">404</h1>
                            <h3 className="nk-error-title">Form Unavailable</h3>
                            <p className="nk-error-text">
                              We are very sorry for inconvenience. It looks like
                              you’re try to access a form that either has been
                              expired or already submitted.
                            </p>
                          </div>
                        </div>
                      ) : null}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
